// moz667: por culpa de vrdemo
var $ = jQuery;

var is_on_execution = false;

function next_autoenabled_loop() {
    is_on_execution = false;
    setTimeout(autoenabled_loop, 1000);
}

function autoenabled_loop() {
    if (!is_on_execution) {
        is_on_execution = true;
    } else {
        return;
    }

    var do_next_loop = false;
    // $(id).popover('destroy')

    $(".btn-autoenable").each(function () {
        var $this = $(this);

        if (typeof($this.data("enabled-on")) != "undefined") {
            if (!$this.data("enabled-left")) {
                $this.data("enabled-left", parseInt($this.data("enabled-on"), 10) + "");
                do_next_loop = true;
            } else {
                var enabled_left = parseInt($this.data("enabled-left"), 10);

                $this.data("enabled-left", enabled_left - 1);

                if (enabled_left - 1 <= 0) {
                    // Ahora mismo tenemos 2 tipos especialmente los que son un popover
                    // que deberia tener algo en .data("enabled-url") 
                    // y los que simplemente estan desactivados con la css disabled
                    if ($this.data("toggle") == "popover") {
                        $this.popover('dispose').attr("href", $this.data("enabled-url"));
                    }
                    $this.removeClass("disabled btn-primary btn-secondary btn-autoenable").addClass("btn-danger");
                } else {
                    do_next_loop = true;
                }
            }
        } else {
            // TODO: cuando este activo ya quitar del html la clase btn-autoenable y poner la clase btn-danger
            $this.removeClass("disabled btn-primary btn-secondary btn-autoenable").addClass("btn-danger");
        }
    });

    if (do_next_loop) {
        next_autoenabled_loop();
    }
}
autoenabled_loop();
